module.exports = __webpack_public_path__ + "img/lb.56f32195.svg";